'use strict';

require('prop-types');
var React = require('react');
var ObjectHelper = require('../../common/ObjectHelper.js');
var LineItemsWeb = require('./LineItems/LineItemsWeb.js');
var LineItemsMobile = require('./Mobile/LineItemsMobile.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Hidden = require('../../node_modules/@material-ui/core/esm/Hidden/Hidden.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OptionInvoiceBody = function OptionInvoiceBody(props) {
  var settings = props.settings,
      laborItems = props.laborItems,
      materialItems = props.materialItems;
  var hasLineItemImages = laborItems.some(function (item) {
    return ObjectHelper.isPresent(item.image_url);
  }) || materialItems.some(function (item) {
    return ObjectHelper.isPresent(item.image_url);
  });
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 24
  }, React__default["default"].createElement(Hidden, {
    xsDown: true
  }, ObjectHelper.isPresent(laborItems) && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(LineItemsWeb, {
    lineItems: laborItems,
    settings: settings,
    hasLineItemImages: hasLineItemImages
  })), ObjectHelper.isPresent(materialItems) && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(LineItemsWeb, {
    lineItems: materialItems,
    settings: settings,
    isMaterialItems: true,
    hasLineItemImages: hasLineItemImages
  }))), React__default["default"].createElement(Hidden, {
    smUp: true
  }, ObjectHelper.isPresent(laborItems) && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(LineItemsMobile.LineItemsMobile, {
    lineItems: laborItems,
    settings: settings,
    hasLineItemImages: hasLineItemImages
  })), ObjectHelper.isPresent(materialItems) && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(LineItemsMobile.LineItemsMobile, {
    lineItems: materialItems,
    settings: settings,
    isMaterialItems: true,
    hasLineItemImages: hasLineItemImages
  }))));
};

module.exports = OptionInvoiceBody;
